import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  Legend,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from 'recharts';
import { DashboardWidget } from './DashboardWidget';
import type { PlaceComparisonItem } from './types';

type AttentionDurationChartProps = {
  data: PlaceComparisonItem[];
  loading?: boolean;
  title?: string;
};

const formatValue = (value: number) => {
  if (Number.isInteger(value)) return `${value}`;
  return value.toFixed(2).replace('.', ',');
};

const renderBarLabel = (props: any) => {
  const {
    x,
    y,
    width,
    value,
  } = props;

  if (value === undefined || value === null) return null;

  return (
    <text
      x={x + width / 2}
      y={y + 18}
      fill="#ffffff"
      textAnchor="middle"
      fontSize={12}
      fontWeight={700}
    >
      {formatValue(value)}
    </text>
  );
};

export const AttentionDurationChart = ({
  data,
  loading = false,
  title = 'TIEMPO DE ATENCIÓN',
}: AttentionDurationChartProps) => (
  <DashboardWidget title={title} loading={loading} hasData={data.length > 0}>
    <div style={{ width: '100%', height: 280 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{
            top: 10,
            right: 20,
            left: 10,
            bottom: 20,
          }}
          barCategoryGap="28%"
        >
          <CartesianGrid stroke="#e3e3e3" vertical={false} />

          <XAxis
            dataKey="name"
            tick={{ fontSize: 12, fill: '#5f6368' }}
            axisLine={{ stroke: '#cfcfcf' }}
            tickLine={false}
          />

          <YAxis
            tick={{ fontSize: 12, fill: '#5f6368' }}
            axisLine={false}
            tickLine={false}
          />

          <Legend
            verticalAlign="bottom"
            align="center"
            iconType="square"
            wrapperStyle={{
              fontSize: 12,
              color: '#5f6368',
              paddingTop: 16,
            }}
          />

          <Bar dataKey="lima" name="LIMA" fill="#2f3f97" barSize={48}>
            <LabelList dataKey="lima" position="insideTop" content={renderBarLabel} />
          </Bar>

          <Bar dataKey="provincia" name="PROVINCIA" fill="#12b5c9" barSize={48}>
            <LabelList dataKey="provincia" position="insideTop" content={renderBarLabel} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  </DashboardWidget>
);
